import { createSelector } from '@ngrx/store';

import { AppState } from '@store/app.reducers';

export const selectAuthState = (state: AppState) => state.auth;

export const selectAuthData = createSelector(selectAuthState, (auth) => auth.data);

export const selectAuthPermissions = createSelector(selectAuthData, (data) => ({
  facility: data?.facility,
  allow: data?.allow,
  deny: data?.deny,
  haspassthru: data?.haspassthru,
}));

export const selectHasPassThru = createSelector(selectAuthPermissions, (data) => data.haspassthru);

export const selectIsLoggedIn = createSelector(selectAuthState, (auth) => auth.authenticated);

export const selectIsLoggedOut = createSelector(selectIsLoggedIn, (loggedIn) => !loggedIn);

export const selectIsRelogin = createSelector(selectAuthState, (auth) => auth.relogin);

export const selectReloginStatus = createSelector(selectAuthState, (auth) => auth.reloginStatus);

export const selectUser = createSelector(selectAuthData, (auth) => auth.user);

export const selectCustomers = createSelector(selectAuthData, (auth) => auth.customers);

export const selectFacilities = createSelector(selectAuthData, (auth) => auth.facilities);

export const selectScreens = createSelector(selectAuthState, (auth) => auth.screens);

export const selectCurrScreen = createSelector(selectScreens, (screens) => (screens.currScreen ? screens.currScreen.name : ''));

export const selectDistinctPrevScreen = createSelector(selectScreens, (screens) =>
  screens.distinctPrevScreen ? screens.distinctPrevScreen : ''
);

export const selectHasModuleChanged = createSelector(
  selectScreens,
  (screens) => !screens.prevScreen || !screens.currScreen || screens.prevScreen.module !== screens.currScreen.module
);

export const selectIsLockedRoute = createSelector(selectScreens, (screens) => screens.lockRoute);

export const selectApiVersion = createSelector(selectAuthState, (auth) => auth.apiVersion);
